export const SITE_URL = "https://liquidstretch.com";
export const DEFAULT_IMAGE = `${SITE_URL}/images/liquid-stretch-v2-bottle-mockup.png`;

export type SeoConfig = {
  title: string;
  description: string;
  path?: string;
  image?: string;
  type?: "website" | "article" | "product";
  jsonLd?: Array<Record<string, unknown>>;
};

export const organizationJsonLd = {
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: "Vermont Forest",
  url: SITE_URL,
  email: "help@liquidstretch.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "169 Bailey Hill Road",
    addressLocality: "Readsboro",
    addressRegion: "VT",
    postalCode: "05350",
    addressCountry: "US",
  },
};

export const benCareJsonLd = {
  "@type": "Person",
  "@id": `${SITE_URL}/ben-care#person`,
  name: "Ben Care",
  url: `${SITE_URL}/ben-care`,
  sameAs: ["https://x.com/_BenCare"],
  homeLocation: {
    "@type": "Place",
    name: "Readsboro, Vermont",
  },
  description:
    "Ben Care is a Vermont-based founder documenting slow body-care practices, gentle mobility, and the Liquid Stretch formulation journey.",
};

export const productJsonLd = {
  "@type": "Product",
  "@id": `${SITE_URL}/#liquid-stretch-product`,
  name: "Liquid Stretch First Light Harvest",
  brand: {
    "@type": "Brand",
    name: "Liquid Stretch",
  },
  manufacturer: {
    "@id": `${SITE_URL}/#organization`,
  },
  image: DEFAULT_IMAGE,
  url: SITE_URL,
  description:
    "A handcrafted Vermont hemp ingestible oil in organic MCT oil for stretching routines, mobility work, and slow body-care practices.",
  category: "Hemp oil",
  offers: {
    "@type": "Offer",
    url: SITE_URL,
    priceCurrency: "USD",
    price: "90.00",
    availability: "https://schema.org/LimitedAvailability",
    itemCondition: "https://schema.org/NewCondition",
    inventoryLevel: {
      "@type": "QuantitativeValue",
      value: 14,
    },
    seller: {
      "@id": `${SITE_URL}/#organization`,
    },
  },
};

export const websiteJsonLd = {
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: "Liquid Stretch",
  publisher: {
    "@id": `${SITE_URL}/#organization`,
  },
  inLanguage: "en-US",
};

export function canonicalUrl(path = "/") {
  return `${SITE_URL}${path === "/" ? "" : path}`;
}

export function pageJsonLd(config: SeoConfig) {
  const url = canonicalUrl(config.path);
  const baseType =
    config.type === "article"
      ? "Article"
      : config.type === "product"
        ? "Product"
        : "WebPage";

  return {
    "@context": "https://schema.org",
    "@graph": [
      organizationJsonLd,
      websiteJsonLd,
      {
        "@type": baseType,
        "@id": `${url}#webpage`,
        url,
        name: config.title,
        description: config.description,
        image: config.image || DEFAULT_IMAGE,
        isPartOf: {
          "@id": `${SITE_URL}/#website`,
        },
        publisher: {
          "@id": `${SITE_URL}/#organization`,
        },
      },
      ...(config.jsonLd || []),
    ],
  };
}
